import React, { memo, useCallback } from 'react'
import styled from 'styled-components'
import { Typography } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import type { CustomInnerHeaderProps } from 'ag-grid-react'
import { filtersSelector } from '../../../../../redux/context/filters/selectors'
import { setPeriodGroupFilter } from '../../../../../redux/context/filters/actions'
import { StatementColumn } from '../../../types'
import { EnhancedStatementRow } from '../../../utils/dataEnhancement'
import { GridContext } from '../../../../../shared/hooks/useGridContext'

interface HeaderCellRendererProps extends CustomInnerHeaderProps<EnhancedStatementRow> {
  displayName: string
  columnData: StatementColumn
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-block: 5px;
`

// Selector to get only the periodGroup filter (minimizes re-renders)
const selectPeriodGroupId = (state: any) => filtersSelector(state).periodGroup?.id

const HeaderCellRendererComponent: React.FC<HeaderCellRendererProps> = ({ displayName, columnData, api }) => {
  const dispatch = useDispatch()
  const periodGroupFilterId = useSelector(selectPeriodGroupId)

  // Get grid-level context from AG Grid API (not column-level context)
  const gridContext = api?.getGridOption('context') as GridContext | undefined

  const handleHeaderClick = useCallback(() => {
    if (periodGroupFilterId) {
      dispatch(setPeriodGroupFilter(undefined))
    } else {
      dispatch(setPeriodGroupFilter(columnData.periodGroup))
    }
  }, [dispatch, periodGroupFilterId, columnData.periodGroup])

  return (
    <HeaderContainer>
      <Typography.Link disabled={gridContext?.isEditMode} onClick={handleHeaderClick}>
        {displayName}
      </Typography.Link>
    </HeaderContainer>
  )
}

export const HeaderCellRenderer = memo(HeaderCellRendererComponent)
